import {AuthModel} from './_models'
import {isStaff} from './staffAccess'

type TicketingAccess = Partial<Pick<AuthModel, 'ticketingEnabled' | 'rl' | 'staff'>>

// A missing ticketingEnabled means an older backend response; keep ticketing available during
// rolling deployments. Staff have no ticketing in the panel at all: tickets live in the CRM (the operator,
// 2026-10-04: no «تیکت» menu, no ticket pages, no ticket buttons or links; docs/staff-access.md).
export const canUseTicketing = (user?: TicketingAccess | null): boolean =>
  user?.ticketingEnabled !== false && !isStaff(user)
